import { render } from "./FileField.vue?vue&type=template&id=c1caed74&scoped=true&ts=true"
import script from "./FileField.vue?vue&type=script&lang=ts"
export * from "./FileField.vue?vue&type=script&lang=ts"

import "./FileField.vue?vue&type=style&index=0&id=c1caed74&lang=scss&scoped=true"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1caed74"]])

export default __exports__